import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-crm-dashboard',
  templateUrl: './crm-dashboard.component.html',
  styleUrls: ['./crm-dashboard.component.css'],
  standalone: false
})
export class CrmDashboardComponent implements OnInit {

  permissions: any = {};
  isLoading = true;

  // KPI tiles
  totalActiveCustomers = 0;
  totalOpenAr = 0;
  customersWithOverdueBalance = 0;
  openOpportunitiesCount = 0;
  openOpportunitiesValue = 0;
  interactionsThisWeek = 0;
  remindersDueToday = 0;

  // Pipeline by stage
  pipelineStages: any[] = [];

  // Top customers
  topCustomers: any[] = [];

  // At-risk customers
  atRiskCustomers: any[] = [];

  // Salesperson summary
  salespersonSummary: any[] = [];

  // Win/loss
  winLossData: any = null;
  winLossDays = 90;

  constructor(
    private dataService: DataService,
    private localStorage: StorageService,
    private titleService: Title
  ) {
    this.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));
  }

  ngOnInit(): void {
    this.titleService.setTitle('CRM Dashboard');
    this.loadAll();
  }

  loadAll(): void {
    this.isLoading = true;
    this.loadKpis();
    this.loadPipeline();
    this.loadTopCustomers();
    this.loadAtRisk();
    this.loadSalespersonSummary();
    this.loadWinLoss();
  }

  private companyParam(prefix = '?'): string {
    const id = this.localStorage.StorageGet('default_company_id', '');
    return id ? prefix + 'company_id=' + encodeURIComponent(id) : '';
  }

  loadKpis(): void {
    this.dataService.getData('crm/dashboard/kpis' + this.companyParam()).subscribe({
      next: (result: any) => {
        if (result) {
          this.totalActiveCustomers = result.totalActiveCustomers ?? 0;
          this.totalOpenAr = result.totalOpenAr ?? 0;
          this.customersWithOverdueBalance = result.customersWithOverdueBalance ?? 0;
          this.openOpportunitiesCount = result.openOpportunitiesCount ?? 0;
          this.openOpportunitiesValue = result.openOpportunitiesValue ?? 0;
          this.interactionsThisWeek = result.interactionsThisWeek ?? 0;
          this.remindersDueToday = result.remindersDueToday ?? 0;
        }
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  loadPipeline(): void {
    this.dataService.getData('crm/pipeline' + this.companyParam()).subscribe({
      next: (result: any) => {
        this.pipelineStages = result ?? [];
      },
      error: () => {
      }
    });
  }

  loadTopCustomers(): void {
    const endpoint = 'crm/dashboard/top-customers' + this.companyParam();
    this.dataService.getData(endpoint).subscribe({
      next: (result: any) => {
        console.log('loadTopCustomers data:', result);
        this.topCustomers = result ?? [];
      },
      error: () => {
      }
    });
  }

  loadAtRisk(): void {
    this.dataService.getData('crm/dashboard/at-risk' + this.companyParam()).subscribe({
      next: (result: any) => {
        this.atRiskCustomers = result ?? [];
      },
      error: () => {
      }
    });
  }

  loadSalespersonSummary(): void {
    this.dataService.getData('crm/dashboard/salesperson-summary' + this.companyParam()).subscribe({
      next: (result: any) => {
        this.salespersonSummary = result ?? [];
      },
      error: () => {
      }
    });
  }

  loadWinLoss(): void {
    const cp = this.companyParam('&');
    this.dataService.getData('crm/dashboard/win-loss?days=' + this.winLossDays + cp).subscribe({
      next: (result: any) => {
        this.winLossData = result ?? null;
      },
      error: () => {
      }
    });
  }

  onWinLossDaysChange(): void {
    this.loadWinLoss();
  }
}
